// extracted by mini-css-extract-plugin
export default {"root":"talent-header_root__z6UcJ","cancelButton":"talent-header_cancelButton__b+0af"};